function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import foundations from "./foundations";
import components from "./components";
import styles from "./styles";
/**
 * Color mode config
 */

var config = {
  useSystemColorMode: false,
  initialColorMode: "light"
};

var theme = _extends({}, foundations, {
  components: components,
  styles: styles,
  config: config
});

export default theme;